import { useEffect } from "react";
import { useAppDispatch } from "reduxentities/hooks";
import { LOGGED_OUT } from "reduxentities/slices/authSlice";

export function useAdmissionsSessionGuard(isInvalid: boolean) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isInvalid) {
      dispatch(LOGGED_OUT());
    }
  }, [dispatch, isInvalid]);
}
